import { http } from '@/core/api/';

const apiUrl = 'api/pei/academicprogresscalendar';

export default {
  async getCalendar() {
    return await http.get(`${apiUrl}/calendar`);
  },
  async getStudentsByProgressAcademicYear(model) {
    return await http.get(`${apiUrl}/GetStudentsByProgressAcademicYear`, {
      params: model,
    });
  },
  async getProgressReportDetail(params) {
    return await http.get(`${apiUrl}/progressreportdetail`, { params });
  },
  async getProgressReportGoalsAndObjetivesByArea(programServiceAreaId) {
    return await http.get(
      `${apiUrl}/progressreportgoalsandobjetivesbyarea/${programServiceAreaId}`
    );
  },
  async getAdditionalProgressInformation(sie, academicYearId, onlyPsc = false) {
    return await http.get(
      `${apiUrl}/additionalprogressinformation/${academicYearId}/${sie}?onlyPsc=${onlyPsc}`
    );
  },
  async getAcademicProgressLevels() {
    return await http.get(`${apiUrl}/progresslevels`);
  },
  async getWeeks() {
    return await http.get(`${apiUrl}/weeks`);
  },
  async saveProgressReport(model) {
    return await http.post(`${apiUrl}/saveprogressreport`, model);
  },
  async saveAmed(model) {
    return await http.post(`${apiUrl}/amend`, model);
  },
  async saveDiscussion(model) {
    return await http.post(`${apiUrl}/discuss`, model);
  },
  async replaceDiscussionDocument(model) {
    return await http.put(`${apiUrl}/replacediscussiondocument`, model);
  },
  async modifyDiscussionDate(model) {
    return await http.put(`${apiUrl}/modifydiscussiondate`, model);
  },
  async getDiscussionLogHistory(params) {
    return await http.get(`${apiUrl}/loghistory`, { params });
  },
};
